<template src="./about-us.html"></template>

<script>
import CompanyService from 'Services/CompanyService';

export default {
  data() {
    return {
      introducation: {},
      overview: {},
      histories: [],
      i18n: 2,
    };
  },

  created() {
    this.list();
  },

  methods: {
    list() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }

      const paramsIntroducation = {
        type: 1,
        i18n: this.i18n,
      };
      const paramsOverview = {
        type: 2,
        i18n: this.i18n,
      };
      const paramsHistory = {
        type: 3,
        i18n: this.i18n,
      };
      CompanyService.list(paramsIntroducation)
        .then((response) => {
          this.introducation = response.data;
        })
        .catch((errorResponse) => {
          this.$notify({
            text: errorResponse.data.message,
            type: 'error',
          });
        });
      CompanyService.list(paramsOverview)
        .then((response) => {
          this.overview = response.data;
        })
        .catch((errorResponse) => {
          this.$notify({
            text: errorResponse.data.message,
            type: 'error',
          });
        });
      CompanyService.listHistory(paramsHistory)
        .then((response) => {
          this.histories = response.data;
        })
        .catch((errorResponse) => {
          this.$notify({
            text: errorResponse.data.message,
            type: 'error',
          });
        });
    },
  },
};
</script>
<style scoped>
pre {
     text-align: justify;
     white-space: pre-line;
}
</style>
